exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-59c130ac],h2[data-v-59c130ac]{font-size:1.6em}.blog-infinite .post .details[data-v-59c130ac],.single .post .details[data-v-59c130ac]{padding:20px 15px 10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59c130ac","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pressreleases/Home.vue
// module id = 611
// module chunks = 0